<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
    <path d="M16 5.333H0V4h16zM16 11.333H0V10h16z" />
  </g>
</svg>
